import { Navigate, useParams } from "react-router-dom";

export default function RedirectActionSessions() {

    const { actionId } = useParams();

    return <Navigate to={`/dpc/sessions?actionId=${actionId}`} replace />;
}
